import React from 'react';
import ReactDOM from 'react-dom';

import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

import Keyboard from './Keyboard';

const KeyboardPortal = () => {
    const { keyboardContainerRef } = useKeyboard();

    if (!keyboardContainerRef) {
        return null;
    }

    return ReactDOM.createPortal(
        <Keyboard />,
        keyboardContainerRef
    );
};

export default KeyboardPortal;
